/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Tournament_SeedInputs */



/**
* | output |
* | --- |
* | "Seed #{n}" |
*
* @param {Tournament_SeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_seed = /** @type {((inputs: Tournament_SeedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_SeedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tête de série #${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Semilla #${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Seed #${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Seed #${i?.n}`)
	return /** @type {LocalizedString} */ (`Seed #${i?.n}`)
});